import { graphqlClient } from '@/lib/graphql-client';
import { postWorkflowWebhook, readWorkflowResponse } from '@/lib/workflow-webhook';
import { buildGetSickLeaveRequestsQuery } from '../graphql/queries';
import {
  GetSickLeaveRequestsParams,
  SickLeaveRequestsPagingResult,
  SickLeaveRequestWorkflowInput,
  SickLeaveWorkflowResult,
} from '../types/sick-leave.types';

/** Published webhook URL of the SICK_LEAVE_REQUEST Blocks workflow. */
const SICK_LEAVE_REQUEST_WEBHOOK_URL = import.meta.env.VITE_SICK_LEAVE_REQUEST_WEBHOOK_URL ?? '';

export const getSickLeaveRequests = async (
  params: GetSickLeaveRequestsParams
): Promise<{ LeaveRequests: SickLeaveRequestsPagingResult }> => {
  const { pageNo, pageSize, filter = {}, order } = params;
  return graphqlClient.query({
    query: buildGetSickLeaveRequestsQuery(filter, pageNo, pageSize, order),
  }) as Promise<{ LeaveRequests: SickLeaveRequestsPagingResult }>;
};

/**
 * Files sick leave on an employee's behalf through the SICK_LEAVE_REQUEST workflow, which looks up the
 * real Sick Leave category, checks the caller's `hrm::time-off::sick-leave-request` permission, stamps the
 * employee's department and decides `IsDocumentSendByDr` from the sick-leave-certificate rule. A
 * refusal comes back as `IsSuccessful: false` with the workflow's message.
 */
export const requestSickLeave = async (
  input: SickLeaveRequestWorkflowInput
): Promise<SickLeaveWorkflowResult> => {
  const response = await postWorkflowWebhook(
    SICK_LEAVE_REQUEST_WEBHOOK_URL,
    'VITE_SICK_LEAVE_REQUEST_WEBHOOK_URL',
    { ...input }
  );
  const { IsSuccessful, Message } = readWorkflowResponse(response, 'SICK_LEAVE_REQUEST_FAILED');
  return { IsSuccessful, Message: IsSuccessful ? '' : Message };
};
